import { Controller } from 'stimulus'
import { isBackgroundColorDark } from '~/common/helpers/color_utils'
import { onPageLoad } from '~/common/extensions/dom_ready'

/**
 * AdaptiveThemeComponent Controller
 *
 * Automatically switches between light and dark content based on the actual
 * computed background color of a configurable color source element.
 */
export default class extends Controller {
  static targets = ['lightContent', 'darkContent']
  static values = { colorSourceSelector: String }

  connect() {
    this.colorSourceElement = this.element.closest(
      this.colorSourceSelectorValue
    )

    if (!this.colorSourceElement) return

    onPageLoad('AdaptiveThemeComponent', () => {
      this.adaptToTheme()
    })
  }

  adaptToTheme() {
    requestAnimationFrame(() => {
      const isDarkBackground = this.resolveDarkBackground()

      if (isDarkBackground === null) return

      requestAnimationFrame(() => this.toggleContent(isDarkBackground))
    })
  }

  resolveDarkBackground() {
    const backgroundColor = window.getComputedStyle(
      this.colorSourceElement
    ).backgroundColor

    if (
      backgroundColor === 'transparent' ||
      backgroundColor === 'rgba(0, 0, 0, 0)'
    ) {
      // Only adapt if the page has an explicit color_mode override (forced_color_mode or theme_mode param)
      // Without an override, default to showing light content
      if (document.documentElement.dataset.forcedColorMode) {
        return document.documentElement.classList.contains('dark')
      }

      return null
    }

    return isBackgroundColorDark(backgroundColor)
  }

  toggleContent(isDarkBackground) {
    if (this.hasLightContentTarget) {
      this.lightContentTarget.classList.remove('hidden', 'dark:hidden')

      if (isDarkBackground) this.lightContentTarget.classList.add('hidden')
    }

    if (this.hasDarkContentTarget) {
      this.darkContentTarget.classList.remove('hidden', 'dark:block')

      if (!isDarkBackground) this.darkContentTarget.classList.add('hidden')
    }
  }
}
